import axios from "axios";
import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import { axiosConfig } from "../../Helpers/AxiosRequest";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useModal } from "../../Contexts/ModalContext";
import NewAddForm from "../../components/NewAddForm";
import { useHeader } from "../../Contexts/HeaderContext";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { API_URL } from "../../Helpers/api";

dayjs.locale("es");

const AdminPanel = () => {
  const { headerRef } = useHeader();
  const { openModal } = useModal();
  const [activeTab, setActiveTab] = useState("events");
  const [adds, setAdds] = useState({
    events: [],
    accomodation: [],
    gastronomic: [],
    activity: [],
    entrepreneur: [],
    gallery: [],
  });
  const [addEdit, setAddEdit] = useState();
  const [addEditForm, setAddEditForm] = useState();
  const socialApps = ["facebook", "whatsapp", "instagram", "twitter", "pinterest", "linkedin"];
  const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const [hours, setHours] = useState([]);
  const [minutes, setMinutes] = useState([]);
  const [timeForm, setTimeForm] = useState({
    day: "Domingo",
    openHour: "00",
    openMinute: "00",
    closeHour: "00",
    closeMinute: "00",
    note: "",
  });

  const handleTimeFormChange = (e) => {
    setTimeForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleAddTime = (e) => {
    e.preventDefault();
    // const time = {
    //   day: timeForm.day,
    //   open: `${timeForm.openHour}:${timeForm.openMinute}`,
    //   close: `${timeForm.closeHour}:${timeForm.closeMinute}`,
    //   note: null,
    // };
    // setTimetable((prev) => [...prev, time]);
  };

  const handleActiveTab = (newActive) => {
    if (activeTab === newActive) return;
    return setActiveTab(newActive);
  };

  useEffect(() => {
    const hoursArr = [];
    const minutesArr = [];
    for (let i = 0; i < 60; i++) {
      if (i < 24) {
        const h = String(i).padStart(2, "0");
        hoursArr.push(h);
      }
      if (i % 5 === 0) {
        const m = String(i).padStart(2, "0");
        minutesArr.push(m);
      }
    }
    setHours(hoursArr);
    setMinutes(minutesArr);

    axios(axiosConfig("GET", `${API_URL}/advertising/get-all-adds`))
      .then((res) => {
        setAdds((prev) => ({ ...prev, accomodation: res.data.adds.accomodation }));
        setAdds((prev) => ({ ...prev, gastronomic: res.data.adds.gastronomic }));
        setAdds((prev) => ({ ...prev, activity: res.data.adds.activity }));
        setAdds((prev) => ({ ...prev, entrepreneur: res.data.adds.entrepreneur }));
      })
      .catch((err) => console.error(err.message));

    axios(axiosConfig("GET", `${API_URL}/images/get-gallery`)).then((res) => {
      setAdds((prev) => ({ ...prev, gallery: res.data.images }));
    });

    axios(axiosConfig("GET", `${API_URL}/events/get-all`))
      .then(({ data }) => {
        setAdds((prev) => ({ ...prev, events: data.events }));
      })
      .catch((err) => console.error(err.message));
  }, []);

  const handleFormChange = (e) => {
    e.preventDefault();
    if (socialApps.includes(e.target.name)) {
      return setAddEditForm((prev) => ({
        ...prev,
        social: {
          ...prev.social,
          [e.target.name]: e.target.value,
        },
      }));
    }
    if (e.target.name.toLowerCase().includes("phone")) {
      const key = e.target.name.slice(0, -1);
      const index = e.target.name.slice(-1);
      return setAddEditForm((prev) => {
        const updatedArray = [...prev[key]];
        updatedArray[index] = e.target.value;

        return { ...prev, [key]: updatedArray };
      });
    }
    setAddEditForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleEditSubmit = (e, id) => {
    e.preventDefault();

    const data = {
      name: undefined,
      description: undefined,
      email: undefined,
      phone: [],
      mobilePhone: [],
      address: undefined,
      location: undefined,
      social: {
        whatsapp: undefined,
        facebook: undefined,
        instagram: undefined,
        linkedin: undefined,
        twitter: undefined,
        pinterest: undefined,
      },
      enabled: undefined,
    };

    Object.keys(addEditForm).map((key) => {
      if (socialApps.includes(key)) {
        return (data.social[key] = addEditForm[key] === "" ? null : addEditForm[key]);
      }
      if (key.toLowerCase().includes("phone")) {
        if (addEditForm[key][0] === "") {
          return (data[key] = []);
        }
        data[key] = addEditForm[key];
      }
      if (addEditForm[key] === "") {
        return (data[key] = null);
      }
      return (data[key] = addEditForm[key]);
    });

    axios(axiosConfig("PUT", `${API_URL}/advertising/update/${activeTab}/${id}`, data))
      .then((res) => {
        const { updatedAdd } = res.data;
        if (res.data.success) {
          setAdds((prev) => ({
            ...prev,
            [activeTab]: prev[activeTab].map((add) => (add._id === updatedAdd._id ? updatedAdd : add)),
          }));
        }
        setAddEdit(undefined);
        setAddEditForm(undefined);
      })
      .catch((err) => console.error(err.message));
  };

  const handleDelete = (e, id, images) => {
    e.preventDefault();

    axios(axiosConfig("DELETE", `${API_URL}/advertising/delete/${activeTab}/${id}`, null, true))
      .then((res) => {
        if (res.data.success) {
          if (images.length > 0) {
            // console.log(images);
            images.map((image) => {
              return axios(axiosConfig("DELETE", `${API_URL}/images/delete/${image._id}`, true));
            });
          }
          setAdds((prev) => ({
            ...prev,
            [activeTab]: prev[activeTab].filter((add) => add._id !== id),
          }));
        }
      })
      .catch((err) => console.error(err.message));
  };

  const toggleEnabled = (e, id) => {
    e.preventDefault();

    const url = () => {
      if (activeTab === "events") {
        return `${API_URL}/events/toggle-enabled/${id}`;
      } else {
        return `${API_URL}/advertising/toggle-enabled/${activeTab}/${id}`;
      }
    };

    // console.log(url());

    axios(axiosConfig("PATCH", url()))
      .then(({ data }) => {
        if (data.success) {
          setAdds((prev) => ({
            ...prev,
            [activeTab]: prev[activeTab].map((add) => (add._id === id ? data.add : add)),
          }));
        }
      })
      .catch((err) => console.error(err.message));
  };

  return (
    <main className="container py-5" style={{ marginTop: headerRef.current?.offsetHeight }}>
      <div className="position-relative">
        <h1 className="text-center">Panel de control</h1>

        <div className="position-absolute top-0 end-0">
          <button
            className="btn btn-success"
            onClick={() =>
              openModal(<NewAddForm activeTab={activeTab} setAdds={setAdds} />, "Nuevo aviso", "lg")
            }
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </div>
      <div className="row g-2 justify-content-center">
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "events" ? "active" : ""}`}
            onClick={() => handleActiveTab("events")}
          >
            Eventos
          </button>
        </div>
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "accomodation" ? "active" : ""}`}
            onClick={() => handleActiveTab("accomodation")}
          >
            Alojamientos
          </button>
        </div>
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "gastronomic" ? "active" : ""}`}
            onClick={() => handleActiveTab("gastronomic")}
          >
            Gastronomía
          </button>
        </div>
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "activity" ? "active" : ""}`}
            onClick={() => handleActiveTab("activity")}
          >
            Actividades
          </button>
        </div>
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "entrepreneur" ? "active" : ""}`}
            onClick={() => handleActiveTab("entrepreneur")}
          >
            Emprendimientos
          </button>
        </div>
        <div className="col-lg-2">
          <button
            className={`btn btn-outline-success w-100 ${activeTab === "gallery" ? "active" : ""}`}
            onClick={() => handleActiveTab("gallery")}
          >
            Galería
          </button>
        </div>
      </div>
      <div className="row g-3 my-3">
        {activeTab !== "gallery" && activeTab !== "events" ? (
          adds[activeTab]?.map((add) => (
            <div className="col-12" key={add._id}>
              <form>
                <div className="row g-0 bg-light shadow border">
                  <div className="col-md-3 d-flex bg-dark">
                    <img src={add.images[0].url} alt={add.name} className="img-fluid my-auto" />
                  </div>
                  <div className="col-md-8">
                    <div className="p-3 text-center">
                      <h2>
                        {addEdit === add._id ? (
                          <input
                            type="text"
                            name="name"
                            id="name"
                            value={addEditForm.name}
                            onChange={(e) => handleFormChange(e)}
                            className="form-control fs-2"
                          />
                        ) : (
                          <>{add.name}</>
                        )}
                      </h2>
                      <div className="row g-2">
                        <div className="col-md-3">
                          <b>Descripción:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <textarea
                              type="text"
                              name="description"
                              id="description"
                              rows="5"
                              value={addEditForm.description}
                              onChange={(e) => handleFormChange(e)}
                              className="form-control"
                            ></textarea>
                          ) : (
                            <>{add.description}</>
                          )}
                        </div>
                        <div className="col-md-3">
                          <b>Dirección:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <input
                              type="text"
                              name="address"
                              id="address"
                              value={addEditForm.address}
                              onChange={(e) => handleFormChange(e)}
                              className="form-control"
                            />
                          ) : (
                            <>{add.address}</>
                          )}
                        </div>
                        <div className="col-md-3">
                          <b>Ubicación:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <input
                              type="text"
                              name="location"
                              id="location"
                              value={addEditForm.location}
                              onChange={(e) => handleFormChange(e)}
                              className="form-control"
                            />
                          ) : (
                            <>{add.location}</>
                          )}
                        </div>
                        <div className="col-md-3">
                          <b>Email:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <input
                              type="email"
                              name="email"
                              id="email"
                              value={addEditForm.email}
                              onChange={(e) => handleFormChange(e)}
                              className="form-control"
                            />
                          ) : (
                            <>{add.email}</>
                          )}
                        </div>
                        {activeTab === "gastronomic" && (
                          <>
                            <div className="col-md-3">
                              <b>Horarios:</b>
                            </div>
                            <div className="col-md-9">
                              {addEdit === add._id ? (
                                <div className="row g-3">
                                  <div className="col-lg-2 col-12">
                                    <select
                                      name="day"
                                      id="day"
                                      className="form-select"
                                      onChange={handleTimeFormChange}
                                      value={timeForm.day}
                                    >
                                      {days.map((day) => (
                                        <option value={day} key={day}>
                                          {day}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-2 col-6">
                                    <select
                                      name="openHour"
                                      id="openHour"
                                      className="form-select text-center"
                                      onChange={handleTimeFormChange}
                                      value={timeForm.openHour}
                                    >
                                      {hours.map((hour) => (
                                        <option value={hour} key={hour}>
                                          {hour}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-2 col-6">
                                    <select
                                      name="openMinute"
                                      id="openMinute"
                                      className="form-select text-center"
                                      onChange={handleTimeFormChange}
                                      value={timeForm.openMinute}
                                    >
                                      {minutes.map((minute) => (
                                        <option value={minute} key={minute}>
                                          {minute}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-1 col-12 d-flex">
                                    <div className="m-auto">-</div>
                                  </div>
                                  <div className="col-lg-2 col-6">
                                    <select
                                      name="closeHour"
                                      id="closeHour"
                                      className="form-select text-center"
                                      onChange={handleTimeFormChange}
                                      value={timeForm.closeHour}
                                    >
                                      {hours.map((hour) => (
                                        <option value={hour} key={hour}>
                                          {hour}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-2 col-6">
                                    <select
                                      name="closeMinute"
                                      id="closeMinute"
                                      className="form-select text-center"
                                      onChange={handleTimeFormChange}
                                      value={timeForm.closeMinute}
                                    >
                                      {minutes.map((minute) => (
                                        <option value={minute} key={minute}>
                                          {minute}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-1 col-12 d-flex">
                                    <button className="btn btn-success w-100" onClick={handleAddTime}>
                                      <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                  </div>
                                  <div className="col-12">
                                    {add.timetable.map((time) => (
                                      <div className="text-start">
                                        <b>{time.day}:</b>{" "}
                                        <span>
                                          {time.open} - {time.close} {time.note ? `(${time.note})` : ""}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                add.timetable.map((time, i) => (
                                  <p className="text-start mb-1" key={`${add._id}-${i}`}>
                                    <b>{time.day}:</b> {time.open} - {time.close}
                                  </p>
                                ))
                              )}
                            </div>
                          </>
                        )}
                        <div className="col-md-3">
                          <b>Teléfonos:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <div className="row">
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="phone0"
                                  value={addEditForm.phone[0]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="phone1"
                                  value={addEditForm.phone[1]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="phone2"
                                  value={addEditForm.phone[2]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              {add.phone.length > 0 &&
                                add.phone.map((phone) => (
                                  <span key={phone} className="me-4">
                                    {phone}
                                  </span>
                                ))}
                            </>
                          )}
                        </div>
                        <div className="col-md-3">
                          <b>Celulares:</b>
                        </div>
                        <div className="col-md-9 text-md-start">
                          {addEdit === add._id ? (
                            <div className="row">
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="mobilePhone0"
                                  value={addEditForm.mobilePhone[0]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="mobilePhone1"
                                  value={addEditForm.mobilePhone[1]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-4">
                                <input
                                  type="number"
                                  name="mobilePhone2"
                                  value={addEditForm.mobilePhone[2]}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              {add.mobilePhone.length > 0 &&
                                add.mobilePhone.map((phone) => (
                                  <span key={phone} className="me-4">
                                    {phone}
                                  </span>
                                ))}
                            </>
                          )}
                        </div>
                        {Object.keys(add.social).map((key) => (
                          <Fragment key={`${add._id}-${key}`}>
                            <div className="col-md-3">
                              <b>{key}:</b>
                            </div>
                            <div className="col-md-9 text-md-start">
                              {addEdit === add._id ? (
                                <input
                                  type="text"
                                  name={key}
                                  id={key}
                                  value={addEditForm.social[key] ? addEditForm.social[key] : ""}
                                  onChange={(e) => handleFormChange(e)}
                                  className="form-control"
                                />
                              ) : (
                                <>{add.social[key] ? <a href={add.social[key]}>{add.social[key]}</a> : "-"}</>
                              )}
                            </div>
                          </Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1">
                    <div className={`btn-group-vertical w-100 h-100`}>
                      {add.enabled ? (
                        <button
                          className="btn btn-danger rounded-0"
                          onClick={(e) => toggleEnabled(e, add._id)}
                        >
                          Desactivar
                        </button>
                      ) : (
                        <button
                          className="btn btn-success rounded-0"
                          onClick={(e) => toggleEnabled(e, add._id)}
                        >
                          Activar
                        </button>
                      )}
                      {addEdit === add._id ? (
                        <>
                          <button
                            className="btn btn-success rounded-0"
                            onClick={(e) => handleEditSubmit(e, add._id)}
                          >
                            Guardar
                          </button>
                          <button
                            className="btn btn-danger rounded-0"
                            onClick={(e) => {
                              e.preventDefault();
                              setAddEdit(undefined);
                              setAddEditForm(undefined);
                            }}
                          >
                            Salir
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-warning rounded-0"
                            onClick={(e) => {
                              e.preventDefault();
                              setAddEdit(add._id);
                              setAddEditForm(add);
                            }}
                          >
                            Editar
                          </button>
                          <button
                            className="btn btn-danger rounded-0"
                            onClick={(e) => handleDelete(e, add._id)}
                          >
                            Eliminar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          ))
        ) : activeTab === "gallery" ? (
          <div className="row g-1">
            {adds[activeTab]?.map((image) => (
              <div className="col-md-4 col-6" key={image._id}>
                <div
                  className="add-img rounded"
                  style={{ backgroundImage: `url(${image.url})`, aspectRatio: "1 / 1" }}
                ></div>
              </div>
            ))}
          </div>
        ) : (
          activeTab === "events" && (
            <div className="row g-3">
              {adds.events.map((event) => (
                <div key={event._id} className="col-lg-4 col-md-6 col-sm-9 col-12">
                  <div class="card h-100 position-relative rounded ">
                    <div
                      className="add-img rounded"
                      style={{ backgroundImage: `url(${event.images[0].url})`, aspectRatio: "4 / 5" }}
                    ></div>
                    {/* <img src={event.images[0].url} class="card-img-top" alt={event.name} /> */}
                    <div class="card-body">
                      <h5 class="card-title">{event.name}</h5>
                      <p>
                        <i>{event.city}</i>{" "}
                        <a href={event.location} target="_blank" rel="noreferrer">
                          <FontAwesomeIcon icon={faMapLocationDot} />
                        </a>
                      </p>
                      <p>{event.description}</p>
                      {event.moreInfo && <h6>Más Información:</h6>}
                      {event.moreInfo && <p>{event.moreInfo}</p>}
                      {event.contacts.length > 0 && (
                        <div className="text-center">
                          <h5>Contactos</h5>
                          {event.contacts.map((contact) => {
                            if (contact.phone === "") return <div key={contact.name}></div>;
                            return (
                              <p className="mb-0" key={contact.name}>
                                <b>{contact.name}:</b> +
                                {contact.country === "uy"
                                  ? "(598)"
                                  : contact.country === "br"
                                    ? "(55)"
                                    : "(54)"}{" "}
                                {contact.phone.startsWith("0") ? contact.phone.slice(1) : contact.phone}
                              </p>
                            );
                          })}
                        </div>
                      )}
                      {event.register && (
                        <div className="text-center mt-3">
                          <h5>Link de insripción</h5>
                          <p>{event.register}</p>
                        </div>
                      )}
                      <div class="text-center position-absolute top-0 start-0 bg-info rounded py-2 px-3 fw-bold text-center">
                        {event.date &&
                          (() => {
                            const date = dayjs(event.date.substring(0, 10));
                            return (
                              <>
                                <small className="mb-0">{date.format("ddd")}</small>
                                <p className="mb-0 p-0">{date.format("DD")}</p>
                                <small className="mb-0">{date.format("MMM")}</small>
                              </>
                            );
                          })()}
                      </div>
                    </div>
                    <div class="card-footer p-0">
                      <div className="btn-group-vertical w-100">
                        {event.enabled ? (
                          <button
                            className="btn btn-sm btn-danger rounded-0"
                            onClick={(e) => toggleEnabled(e, event._id)}
                          >
                            Desactivar
                          </button>
                        ) : (
                          <button
                            className="btn btn-sm btn-success rounded-0"
                            onClick={(e) => toggleEnabled(e, event._id)}
                          >
                            Activar
                          </button>
                        )}
                        <button
                          className="btn btn-sm btn-warning disabled"
                          onClick={() =>
                            openModal(
                              <NewAddForm activeTab={activeTab} setAdds={setAdds} currentAdd={event} />,
                              "Editar aviso",
                              "lg",
                            )
                          }
                          disabled
                        >
                          Editar
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(e) => handleDelete(e, event._id, event.images)}
                        >
                          Eliminar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </main>
  );
};

export default AdminPanel;
